/* eslint-disable id-length */
import { getSubStepValues } from '#models/general/steps';
import { mapPeriodsOptions } from '#models/periods';
import { getSelectField } from '#utils/select';

import { STATEMENTS_SUBSTEPS_IDS, STATEMENTS_INFORMATION_FIELDS } from './constants';

export const getStatementInformationPageFields = ({ values, errors, periods }) => {
  const getStatementInformationPageValues = getSubStepValues(
    STATEMENTS_SUBSTEPS_IDS.STATEMENT_INFORMATION,
    values,
    errors
  );

  const getSelectFieldFrom = field =>
    getSelectField({
      field,
      values,
      options: mapPeriodsOptions(periods),
      customOptions: true,
      getValues: getStatementInformationPageValues
    });

  return [
    getSelectFieldFrom(STATEMENTS_INFORMATION_FIELDS.PERIOD_ID),
    getSelectFieldFrom(STATEMENTS_INFORMATION_FIELDS.PREVIOUS_PERIOD_ID),
    getSelectFieldFrom(STATEMENTS_INFORMATION_FIELDS.FEINT_PERIOD_ID)
  ];
};
